type ValueReplaceMap = Record<string, string | number | React.ReactNode>

// Function to replace the tags in Prismic text with local state values
const replacePlaceholders = (content: string, valueReplaceMap: ValueReplaceMap) =>
    content
        .split(new RegExp(`(${Object.keys(valueReplaceMap).join('|')})`, 'gi'))
        .map((part) => valueReplaceMap[part] ?? part)

export default replacePlaceholders
